import { IconButton, TextField } from "@material-ui/core";
import ClearIcon from '@material-ui/icons/Clear';
import React, { useState, useCallback } from "react";

const GlobalFilter2 = ({ setGlobalFilter, diff }) => {
    const [filterValue, setFilterValue] = useState('');

    const handleChange = useCallback((event) => {
        if (event) {
            setFilterValue(event.target.value || undefined);
            setGlobalFilter(event.target.value || undefined);
        } else {
            setFilterValue('');
            setGlobalFilter('');
        }
    }, [setGlobalFilter, setFilterValue])

    const isShrink = (v) => {
        if (v) {
            return true;
        } else {
            return false;
        }
    }

    const getClearButton = (value) => {
        if (value) {
            return (
                <IconButton onClick={() => handleChange(null)}>
                    <ClearIcon />
                </IconButton>
            )
        } else {
            return <></>;
        }
    }

    React.useEffect(() => {
        if (filterValue && diff === 0) {
            handleChange(null);
        }
    }, [diff, filterValue, handleChange]);

    return (
        <TextField
            className="text-column-filter global"
            variant="outlined"
            size='small'
            value={filterValue}
            onChange={handleChange}
            label="Keresés"
            InputProps={{
                endAdornment: getClearButton(filterValue)
            }}
            InputLabelProps={{ shrink: isShrink(filterValue), style: { fontSize: 12, top: '2px' } }}
        />
    );
};

export default GlobalFilter2;